import "core-js/modules/es.array.concat.js";
import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取货到付款手续费数据列表（#61）
 */
export function getTransportList() {
  return request("".concat(BASE_URL) + "/transport/list", METHOD.GET);
}

/**
 * 获取运输方式详情（#9995）
 */
export function getTransportDetail(id) {
  return request("".concat(BASE_URL) + "/transport/detail/" + id, METHOD.GET);
}

/** 新建运输方式数据（#58）
 * @param {Object} data
 */
export function addTransport(data) {
  return request("".concat(BASE_URL) + "/transport", METHOD.POST, data);
}

/** 编辑运输方式数据（#59）
 * @param {Object} data
 */
export function updateTransport(data) {
  return request("".concat(BASE_URL) + "/transport", METHOD.PUT, data);
}

/** 删除货到付款手续费（#64）
 * @param {Object} data
 */
export function deleteTransport(id) {
  return request("".concat(BASE_URL) + "/transport/" + id, METHOD.DELETE);
}

// 启用禁用 #60
export function changeTransportStatus(id, status) {
  return request("".concat(BASE_URL) + "/transport/changeStatus/".concat(id, "/?status=").concat(status), METHOD.PUT);
}
export default {
  getTransportList: getTransportList,
  getTransportDetail: getTransportDetail,
  addTransport: addTransport,
  updateTransport: updateTransport,
  deleteTransport: deleteTransport
};